import { useEffect, useState } from "react";
import { unitType } from "../../../util/unitType";
import { reformatData } from "../../../util/helperFunctions";
import { getModelPlotData } from "../util/modelUtils";
import { toast } from "react-toastify";
import moment from "moment";
import { fetchExpressions } from "../../../api/sensorApi";

const features = [
    {
        id: "TrainedModelCorrosionRate",
        name: "Trained Model Predicted Corrosion Rate",
    }
]


function useGetTrainModelCR(id, start, end, units, currTab, list, modelId) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (id && currTab === "cr") {
            const spec = {
                subject_filter: `sensor.id = '${id}'`,
                start: moment(start).format("YYYY-MM-DD"),
                end: moment(end).format("YYYY-MM-DD"),
                expressions: ["TrainedModelCorrosionRate"],
                units: [`${unitType(units, 'velocity mils')}`],
                interval: "D",
                model_id: modelId,
            }
            setLoading(true);
            fetchExpressions("SensorExpression", spec).then((res) => {
                res = reformatData([res]);
                res = getModelPlotData(res?.[0], features, units, id);
                console.log("Fetched Corrosion Rate Data:", res);
                setData(res);
            }).catch((error) => {
                console.error(error);
                toast.error("Error fetching Corrosion Rate Data")
            }).finally(() => setLoading(false));

        }

    }, [id, start, end, units, currTab, list, modelId]);
    return { data, loading }
}

export default useGetTrainModelCR;